module.exports = __webpack_public_path__ + "files/75d7e1c156436b601dbad60b14f9fea9.png";